import React from "react";
import { Container, Button, Jumbotron, Spinner } from "react-bootstrap";

export default function Welcome(props) {
  // If there's an error, show the welcome screen with a login button
  if (props.error) {
    return (
      <Container>
        <Jumbotron>
          <h1>Welcome to EPIIC</h1>
          <p className="text-danger">Authentication error: {props.error.message}</p>
          <Button color="primary" onClick={props.authButtonMethod}>
            Try again
          </Button>
        </Jumbotron>
      </Container>
    );
  }
  
  // Otherwise, show a loading spinner while authentication is happening
  return (
    <Container className="d-flex justify-content-center align-items-center vh-100">
      <div className="text-center">
        <h2>Signing in to EPIIC</h2>
        <Spinner animation="border" role="status" className="mt-3">
          <span className="sr-only">Loading...</span>
        </Spinner>
      </div>
    </Container>
  );
}